module.exports = __webpack_public_path__ + "static/media/14.97985d86.jpg";